/**
 * 更新登录用户信息
 */
export const SET_USER = "setUser";

/**
 * 退出操作
 */
export const CLEAR_USER = "clearUser";




// WEBPACK FOOTER //
// ./src/store/mutation-types.js